"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    MenuTrigger: function() {
        return _index.MenuTrigger;
    },
    renderMenuTrigger_unstable: function() {
        return _index.renderMenuTrigger_unstable;
    },
    useMenuTrigger_unstable: function() {
        return _index.useMenuTrigger_unstable;
    }
});
const _index = require("./components/MenuTrigger/index");
